export default __webpack_public_path__ + "static/media/LeveeParkRiver.84b7c886.jpg";